import {
  AccountView,
  ClientCreateView,
  ClientDetailView,
  ClientsList,
  DashboardView,
  EmailVerificationView,
  InvoiceCreateView,
  InvoiceList,
  InvoiceSettingsView,
  LoginView,
  MyCompanyView,
  OnboardingView,
  ProductList,
  ProfileView,
  QuotationDetailView,
  QuotationListView,
  RegistrationCompleteView,
  SettingsView,
} from '@views'
import { Navigate } from 'react-router-dom'
import { DefaultWithHeader, DefaultWithoutMenu, UnauthenticatedLayout } from 'src/layouts/index.layouts'
import { ForgotPasswordView } from 'src/views/forgot-password/forgot-password.view'
import { InvoiceDetail } from 'src/views/invoiceDetail/invoiceDetail.view'
import { QuotationCreateView } from 'src/views/quotationCreate/quotationCreate.view'
import { SignupView } from 'src/views/register/register-view'
import { ResetPasswordView } from 'src/views/reset-password/reset-password.view'
import { KEYS } from './keys.contants'

export const ROUTE_PARTS = {
  ROOT: '/',
  INVOICE_CREATE: 'maak-factuur',
  INVOICE_LIST: 'facturen',
  INVOICE_SINGLE: ':id',
  CLIENT_LIST: 'klanten',
  CLIENT_DETAIL: ':id',
  CLIENT_CREATE: 'nieuwe-klant',
  LOGIN: 'login',
  FORGOT_PASSWORD: 'wachtwoord-vergeten',
  RESET_PASSWORD: 'wachtwoord-resetten',
  VERIFY_EMAIL: 'email-verifiëren',
  REGISTRATION_COMPLETE: 'registratie-compleet',
  ACCOUNT: 'account',
  PROFILE: 'profile',
  QUOTE_LIST: 'offertes',
  QUOTE_DETAIL: ':id',
  QUOTE_CREATE: 'maak-offerte',
  DASHBOARD: 'dashboard',
  SIGNUP: 'aanmelden',
  SETTINGS: 'instellingen',
  WELCOME: 'welcome',
  MY_COMPANY: 'mijn-onderneming',
  PRODUCT_LIST: 'producten',
  PRODUCT_CREATE: 'nieuw-product',
  PRODUCT_DETAIL: ':id',
}

export const URL_PATHS = {
  ACCOUNT: `/${ROUTE_PARTS.ACCOUNT}`,
  CLIENT_LIST: `/${ROUTE_PARTS.CLIENT_LIST}`,
  CLIENT_CREATE: `/${ROUTE_PARTS.CLIENT_LIST}/${ROUTE_PARTS.CLIENT_CREATE}`,
  CLIENT_DETAIL: `/${ROUTE_PARTS.CLIENT_LIST}/${ROUTE_PARTS.CLIENT_DETAIL}`,
  DASHBOARD: `/${ROUTE_PARTS.DASHBOARD}`,
  FORGOT_PASSWORD: `/${ROUTE_PARTS.FORGOT_PASSWORD}`,
  VERIFY_EMAIL: `/${ROUTE_PARTS.VERIFY_EMAIL}`,
  REGISTRATION_COMPLETE: `/${ROUTE_PARTS.REGISTRATION_COMPLETE}`,
  INVOICE_LIST: `/${ROUTE_PARTS.INVOICE_LIST}`,
  INVOICE_CREATE: `/${ROUTE_PARTS.INVOICE_LIST}/${ROUTE_PARTS.INVOICE_CREATE}`,
  INVOICE_DETAIL: `/${ROUTE_PARTS.INVOICE_LIST}/${ROUTE_PARTS.INVOICE_SINGLE}`,
  INVOICE_SETTINGS: `/${ROUTE_PARTS.INVOICE_LIST}/${ROUTE_PARTS.SETTINGS}`,
  LOGIN: `/${ROUTE_PARTS.LOGIN}`,
  MY_COMPANY: `/${ROUTE_PARTS.MY_COMPANY}`,
  PROFILE: `/${ROUTE_PARTS.PROFILE}`,
  QUOTE_LIST: `/${ROUTE_PARTS.QUOTE_LIST}`,
  QUOTE_CREATE: `/${ROUTE_PARTS.QUOTE_LIST}/${ROUTE_PARTS.QUOTE_CREATE}`,
  QUOTE_DETAIL: `/${ROUTE_PARTS.QUOTE_LIST}/${ROUTE_PARTS.QUOTE_DETAIL}`,
  QUOTE_SETTINGS: `/${ROUTE_PARTS.QUOTE_LIST}/${ROUTE_PARTS.SETTINGS}`,
  RESET_PASSWORD: `/${ROUTE_PARTS.RESET_PASSWORD}`,
  ROOT: '/',
  SIGNUP: `/${ROUTE_PARTS.SIGNUP}`,
  WELCOME: `/${ROUTE_PARTS.WELCOME}`,
  SETTINGS: `/${ROUTE_PARTS.SETTINGS}`,
  PRODUCT_LIST: `/${ROUTE_PARTS.PRODUCT_LIST}`,
  PRODUCT_CREATE: `/${ROUTE_PARTS.PRODUCT_LIST}/${ROUTE_PARTS.PRODUCT_CREATE}`,
  PRODUCT_DETAIL: `/${ROUTE_PARTS.PRODUCT_LIST}/${ROUTE_PARTS.PRODUCT_DETAIL}`,
}

export const ROUTES = [
  {
    id: KEYS.LOGIN,
    path: URL_PATHS.LOGIN,
    element: <LoginView />,
    layout: <UnauthenticatedLayout />,
  },
  {
    id: KEYS.SIGNUP,
    path: URL_PATHS.SIGNUP,
    element: <SignupView />,
    layout: <UnauthenticatedLayout />,
  },
  {
    id: KEYS.FORGOT_PASSWORD,
    path: URL_PATHS.FORGOT_PASSWORD,
    element: <ForgotPasswordView />,
    layout: <UnauthenticatedLayout />,
  },
  {
    id: KEYS.RESET_PASSWORD,
    path: URL_PATHS.RESET_PASSWORD,
    element: <ResetPasswordView />,
    layout: <UnauthenticatedLayout />,
  },
  {
    id: KEYS.VERIFY_EMAIL,
    path: URL_PATHS.VERIFY_EMAIL,
    element: <EmailVerificationView />,
    layout: <UnauthenticatedLayout />,
  },
  {
    path: URL_PATHS.WELCOME,
    element: <DefaultWithoutMenu />,
    children: [
      {
        id: KEYS.WELCOME,
        element: <OnboardingView />,
        index: true,
      },
    ],
  },
  {
    id: KEYS.REGISTRATION_COMPLETE,
    path: URL_PATHS.REGISTRATION_COMPLETE,
    element: <RegistrationCompleteView />,
    layout: <DefaultWithoutMenu />,
  },
  {
    path: ROUTE_PARTS.ROOT,
    element: <DefaultWithHeader />,
    children: [
      {
        id: KEYS.QUOTE_LIST,
        path: ROUTE_PARTS.QUOTE_LIST,
        children: [
          {
            element: <QuotationListView />,
            index: true,
          },
          {
            id: KEYS.QUOTE_SINGLE,
            path: ROUTE_PARTS.QUOTE_DETAIL,
            element: <QuotationDetailView />,
            allowed: [],
          },
          {
            id: KEYS.QUOTE_CREATE,
            path: ROUTE_PARTS.QUOTE_CREATE,
            element: <QuotationCreateView />,
            allowed: [],
          },
          {
            id: KEYS.QUOTE_SETTINGS,
            path: ROUTE_PARTS.SETTINGS,
            element: <div>Offerte Instellingen</div>,
          },
        ],
        allowed: [],
      },
      {
        id: KEYS.INVOICE_LIST,
        segment: ROUTE_PARTS.INVOICE_LIST,
        path: ROUTE_PARTS.INVOICE_LIST,
        children: [
          {
            index: true,
            element: <InvoiceList />,
          },
          {
            id: KEYS.INVOICE_SINGLE,
            path: ROUTE_PARTS.INVOICE_SINGLE,
            segment: ROUTE_PARTS.INVOICE_LIST,
            element: <InvoiceDetail />,
            allowed: [],
          },
          {
            id: KEYS.INVOICE_CREATE,
            path: ROUTE_PARTS.INVOICE_CREATE,
            element: <InvoiceCreateView />,
            allowed: [],
          },
          {
            id: KEYS.INVOICE_SETTINGS,
            path: ROUTE_PARTS.SETTINGS,
            element: <InvoiceSettingsView />,
          },
        ],
        allowed: [],
      },
      {
        id: KEYS.CLIENT_LIST,
        path: ROUTE_PARTS.CLIENT_LIST,
        allowed: [],
        children: [
          {
            element: <ClientsList />,
            index: true,
          },
          {
            id: KEYS.CLIENT_DETAIL,
            path: ROUTE_PARTS.CLIENT_DETAIL,
            element: <ClientDetailView />,
            allowed: [],
          },
          {
            id: KEYS.CLIENT_CREATE,
            path: ROUTE_PARTS.CLIENT_CREATE,
            element: <ClientCreateView />,
            allowed: [],
          },
        ],
      },
      {
        path: ROUTE_PARTS.DASHBOARD,
        id: KEYS.DASHBOARD,
        index: true,
        element: <DashboardView />,
        allowed: [],
      },
      {
        path: ROUTE_PARTS.PROFILE,
        id: KEYS.PROFILE,
        element: <ProfileView />,
        allowed: [],
      },
      {
        path: ROUTE_PARTS.ACCOUNT,
        id: KEYS.ACCOUNT,
        element: <AccountView />,
        allowed: [],
      },
      {
        path: ROUTE_PARTS.MY_COMPANY,
        id: KEYS.MY_COMPANY,
        element: <MyCompanyView />,
        allowed: [],
      },
      {
        path: ROUTE_PARTS.SETTINGS,
        id: KEYS.SETTINGS,
        element: <SettingsView />,
        allowed: [],
      },
      {
        path: ROUTE_PARTS.PRODUCT_LIST,
        id: KEYS.PRODUCT_LIST,
        element: <ProductList />,
        allowed: [],
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to={URL_PATHS.DASHBOARD} />,
  },
  // {
  //   path: '/*',
  //   element: <Navigate to={URL_PATHS.LOGIN} />,
  // },
]
